<template>
  <div class="courses">
    <ag-table :data-source-api="getAllCourses" :grid-options="gridOptions" :permissions="permissions" :rtl="false"
      :is-entities-response="false" @emitAddNewRecord="onCreateCourse()" />

    <tm-popup :submit="onCoursePopupSubmit" :title="coursePopupTitle" ref="coursePopup">
      <div class="vx-row justify-start">
        <div class="vx-col w-full mb-2 mt-2">
          <tm-input class="w-full" name="اسم الفرصة التدريبية" placeholder="اسم الفرصة التدريبية" type="text" validation-rules="required"
            v-model="course.name" />
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
          <tm-input class="w-full" name="عدد المقاعد" placeholder="عدد المقاعد" type="number"
            validation-rules="required" v-model="course.totalSeats" />
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
          <tm-input class="w-full" name="من تاريخ" placeholder="من تاريخ" type="date" v-model="course.startDate"
            validation-rules="required" />
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
          <tm-input class="w-full" name="إلى تاريخ" placeholder="إلى تاريخ" type="date" v-model="course.endDate"
            validation-rules="required" />
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
          <tm-input class="w-full" name="من الساعة" placeholder="من الساعة" type="time" v-model="course.startTime"
            validation-rules="required" />
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
          <tm-input class="w-full" name="إلى الساعة" placeholder="إلى الساعة" type="time" v-model="course.endTime"
            validation-rules="required" />
        </div>
        <div class="vx-col w-full mb-2 mt-2">
          <tm-input class="w-full" name="الرابط" placeholder="الرابط" type="text"
            :validation-rules="{ required: true, regex: /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/\S*)?$/ }"
            v-model="course.registrationFormUrl" />
        </div>
        <div class="vx-col w-full mb-2 mt-4">
          <p class="mt-2 px-2" style="font-size: smaller">الوصف</p>
          <tm-text-area class="w-full" name="الوصف" validation-rules="required" v-model="course.description" />
        </div>
      </div>
    </tm-popup>
  </div>
</template>

<script>
import { RepositoryFactory } from "../../volunteer-repositories/volunteerRepositoryFactory";
import AgTable from "@/app/shared/shared-components/ag-grid/AgTableServerSide";
import AgTableBtnCell from "@/app/shared/shared-components/ag-grid/AgTableBtnCell";
import AgButton from "@/app/shared/shared-components/ag-grid/AgButton";
import TmPopup from "@/app/shared/shared-components/TmPopup";
import TmInput from "@/app/shared/shared-components/TmInput";
import TmTextArea from "@/app/shared/shared-components/TmTextArea";
import utilities from "@/app/shared/utilities/index";
import moment from 'moment';

const coursesRepo = RepositoryFactory.get("coursesRepository");

export default {
  name: "CoursesManagement",
  components: {
    TmInput,
    TmTextArea,
    AgTable,
    TmPopup,
    // eslint-disable-next-line vue/no-unused-components
    AgButton,
    // eslint-disable-next-line vue/no-unused-components
    AgTableBtnCell,
  },
  data() {
    return {
      gridApi: null,
      gridOptions: null,
      coursePopupTitle: 'إضافة فرصة تدريبية جديدة',
      status: {
        pending: "قيد الانتظار",
        in_progress: "قيد التنفيذ",
        completed: "تم التنفيذ",
        finished: "مكتمل",
      },
      courseTypes: {
        zadi_session: "جلسة زادي",
        training_course: "فرصة تدريبية",
      },
      permissions: {
        add: "training_courses_management",
        edit: "training_courses_management",
        delete: "training_courses_management",
        "view-users": "volunteer_manage",
      },
      course: {
        name: null,
        description: null,
        type: 'training_course',
        startDate: null,
        endDate: null,
        startTime: null,
        endTime: null,
        totalSeats: null,
        registrationFormUrl: null,
        status: 'pending'
      },
    };
  },
  methods: {
    createColDefs() {
      let self = this;
      return [
        {
          headerName: "المعرف",
          field: "id",
          sortable: true,
          width: 200,
        },
        {
          headerName: "الفرصة التدريبية",
          field: "name",
          filter: "agTextColumnFilter",
          width: 210,
          sortable: false,
        },
        {
          headerName: "الوصف",
          field: "description",
          filter: "agTextColumnFilter",
          width: 210,
          sortable: false,
        },
        {
          headerName: "من تاريخ",
          field: "startDate",
          filter: "agDateColumnFilter",
          width: 200,
          sortable: false,
          valueGetter: function getObject(data) {
            return data.data.startDate ? utilities.formatDate(data.data.startDate, "yyyy-MM-DD") : '-';
          },
        },
        {
          headerName: "إلى تاريخ",
          field: "endDate",
          filter: "agDateColumnFilter",
          width: 200,
          sortable: false,
          valueGetter: function getObject(data) {
            return data.data.endDate ? utilities.formatDate(data.data.endDate, "yyyy-MM-DD") : '-';
          },
        },
        {
          headerName: "الحالة",
          field: "status",
          width: 210,
          sortable: false,
          valueGetter: function getObject(params) {
            return self.status[params.data.status] || "-";
          },
          filter: "agSetColumnFilter",
          filterParams: {
            values: Object.keys(self.status),
            valueFormatter: (params) =>
              self.status[params.value] || params.value,
          },
        },
        {
          headerName: "النوع",
          field: "type",
          width: 210,
          sortable: false,
          valueGetter: function getObject(params) {
            return self.courseTypes[params.data.type] || "-";
          },
        },
        {
          headerName: "عدد المقاعد",
          field: "totalSeats",
          width: 210,
          sortable: false,
        },
        {
          headerName: "المتطوعين",
          width: 210,
          sortable: false,
          cellRendererFramework: AgButton,
          valueGetter: function getObject(params) {
            return params.data.id;
          },
          cellRendererParams: (params) => {
            return {
              size: "small",
              color: "primary",
              name: "إسناد المتطوعين",
              type: "gradient",
              disabled: !["pending"].includes(params.data.status),
              click(courseId) {
                self.$router.push({
                  path: `/volunteers/courses/${courseId}/assign`,
                });
              },
            };
          },
        },
        {
          headerName: "إغلاق التسجيل",
          width: 210,
          sortable: false,
          cellRendererFramework: AgButton,
          valueGetter: function getObject(params) {
            return params.data.id;
          },
          cellRendererParams: (params) => {
            return {
              size: "small",
              color: "primary",
              name: "إغلاق التسجيل",
              type: "gradient",
              disabled: ["pending", "finished", "completed"].includes(params.data.status),
              click(courseId) {
                self.onCompleteCourse(courseId);
              },
            };
          },
        },
        {
          headerName: "إنهاء التدريب",
          width: 210,
          sortable: false,
          cellRendererFramework: AgButton,
          valueGetter: function getObject(params) {
            return params.data.id;
          },
          cellRendererParams: (params) => {
            return {
              size: "small",
              color: "primary",
              name: "إنهاء التدريب",
              type: "gradient",
              disabled: ["pending", "finished", "in_progress"].includes(params.data.status),
              click(courseId) {
                self.onFinishCourse(courseId);
              },
            };
          },
        },
        {
          headerName: "الإجراءات",
          cellRendererFramework: AgTableBtnCell,
          sortable: false,
          valueGetter: function getObject(params) {
            return params.data;
          },
          cellRendererParams: {
            editRecord: function (course) {
              self.onUpdateCourse(course);
            },
            deleteRecord: function (course) {
              self.onRemoveCourse(course);
            },
            repeatRecord: function (course) {
              self.onRepeatCourse(course);
            },
            viewUsersRecord: function (course) {
              self.$router.push({
                path: `/volunteers/courses/${course.id}/volunteers`,
              });
            },
            actions: ["edit", "delete","repeat", "view-users"],
            permissions: self.permissions,
          },
        },
      ];
    },
    async onCompleteCourse(courseId) {
      await coursesRepo.completeCourse(courseId);
      await this.gridApi.refreshServerSideStore({ purge: true });
    },
    async onFinishCourse(courseId) {
      await coursesRepo.finishCourse(courseId);
      await this.gridApi.refreshServerSideStore({ purge: true });
    },
    async onRemoveCourse(course) {
      await coursesRepo.removeCourse(course.id);
      await this.gridApi.refreshServerSideStore({ purge: true });
    },
    async onRepeatCourse(course) {
      await coursesRepo.repeatCourse(course.id);
      await this.gridApi.refreshServerSideStore({ purge: true });
    },
    async getAllCourses(query) {
      return await coursesRepo.fetchCourses(`${query}&sort=createdAt,DESC&filter=status||$ne||finished&filter=type||$eq||training_course`);
    },
    onUpdateCourse(course) {
      this.coursePopupTitle = 'تعديل الفرصة التدريبية';
      this.resetCourseForm();
      Object.assign(this.course, {
        ...course,
        startDate: utilities.formatDate(course.startDate, "yyyy-MM-DD"),
        endDate: utilities.formatDate(course.endDate, "yyyy-MM-DD"),
      });
      this.$refs.coursePopup.open();
    },
    onCreateCourse() {
      this.coursePopupTitle = 'إضافة فرصة تدريبية جديدة';
      this.resetCourseForm();
      this.$refs.coursePopup.open();
    },
    resetCourseForm() {
      Object.assign(this.course, {
        name: null,
        description: null,
        type: 'training_course',
        startDate: null,
        endDate: null,
        startTime: null,
        endTime: null,
        totalSeats: null,
        registrationFormUrl: null,
        status: 'pending'
      });
    },
    async onCoursePopupSubmit() {
      const course = {
        ...this.course,
        type: 'training_course',
        startTime: moment(this.course.startTime, "HH:mm").format("HH:mm:ss"),
        endTime: moment(this.course.endTime, "HH:mm").format("HH:mm:ss"),
        totalSeats: Number(this.course.totalSeats),
      };
      try {
        if (this.coursePopupTitle == 'إضافة فرصة تدريبية جديدة') {
          await coursesRepo.createCourse(course);
        } else {
          await coursesRepo.updateCourse(course);
        }
        this.$refs.coursePopup.close();
        await this.gridApi.refreshServerSideStore({ purge: true });
        this.resetCourseForm();
      } catch (err) {
        this.$refs.coursePopup.endLoading();
      }
    },
  },
  created() {
    this.gridOptions = {};
    this.gridOptions.columnDefs = this.createColDefs();
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
  },
};
</script>
